import React from "react";

import { useCheckPasswordStrength, useTranslation } from "utils";

import { Flex, Input, InputPassword, PasswordStrengthPopup } from "components";

export const PasswordResetInputs = () => {
  const { t } = useTranslation("signinup");
  const { setPasswordMatch, setPasswordStrength, currentPasswordStrength } = useCheckPasswordStrength();

  const handlePasswordChange = (e: React.ChangeEvent<Element>, inputNumber: number) => {
    if (inputNumber === 1) {
      setPasswordStrength(e);
    }

    if (inputNumber === 2) {
      setPasswordMatch(e);
    }
  };

  return (
    <Flex vertical gap={32}>
      <Input
        name="email"
        label={t("changePassword.inputs.email")}
        rules={[
          {
            required: true,
            type: "email",
          },
        ]}
      />
      <Flex wrap gap={32} className="account-field-pair">
        <InputPassword
          name="password"
          label={t("changePassword.inputs.password")}
          PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
          rules={[{ required: true }]}
          onChange={(e) => handlePasswordChange(e, 1)}
        />
        <InputPassword
          name="confirmPassword"
          label={t("changePassword.inputs.confirmPassword")}
          PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
          rules={[{ required: true }]}
          onChange={(e) => handlePasswordChange(e, 2)}
        />
      </Flex>
    </Flex>
  );
};
